export default function InputRadio({ label, labelFirst = false, className, ...props }) {
  return (
    <div className="flex items-center">
      {label && labelFirst && <label className="mr-0.5">{label}</label>}
      <input type="radio" className={`p-2 mr-2 ${className}`} {...props} />
      {label && !labelFirst && <label className="mr-1">{label}</label>}
    </div>
  );
}
